import {
    AccountAccess,
    CompanyUserProductEntitlements,
    CompanyUserProductLimits,
} from '@treasury/domain/company/user';
import { TmBaseComponent } from '@treasury/presentation';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './partials/account-entitlement-defaults.component';
import './partials/account-list.component';
import './partials/product-entitlements.component';
import './partials/product-limits.component';

@customElement('tm-company-user-limits-and-entitlements-common')
export class CompanyUserLimitsAndEntitlementsCommon extends TmBaseComponent {
    @property()
    public accounts?: AccountAccess[] = [];

    @property()
    public limits?: CompanyUserProductLimits;

    @property()
    public companyId?: number;

    @property()
    public userId?: number;

    @property()
    public entitlements?: CompanyUserProductEntitlements;

    public render() {
        return html`
            <div class="flex flex-col gap-y-5">
                ${this.renderLimits()} ${this.renderEntitlements()}
            </div>
        `;
    }

    private renderLimits() {
        return html`
            <div>
                <tm-company-user-product-limits
                    .limits=${this.limits}
                ></tm-company-user-product-limits>
            </div>
        `;
    }

    private renderEntitlements() {
        return html`
            <div class="mb-7">
                <div class="text-lg font-bold">Entitlements</div>
                <div class="flex flex-col gap-y-10">
                    ${this.renderProductEntitlements()} ${this.renderAccountEntitlementDefaults()}
                </div>
            </div>
            <div>
                <tm-company-user-account-list
                    .companyId=${this.companyId}
                    .userId=${this.userId}
                    .accounts=${this.accounts}
                    .entitlements=${this.entitlements}
                >
                </tm-company-user-account-list>
            </div>
        `;
    }

    private renderAccountEntitlementDefaults() {
        if (!this.entitlements || this.entitlements?.accountProductClaims.length < 1) {
            return nothing;
        }
        return html`<tm-company-user-account-entitlement-defaults
            .entitlements=${this.entitlements}
        >
        </tm-company-user-account-entitlement-defaults>`;
    }

    private renderProductEntitlements() {
        if (!this.entitlements || this.entitlements?.userProductClaims.length < 1) {
            return nothing;
        }
        return html`<tm-company-user-product-entitlements
            .entitlements=${this.entitlements?.userProductClaims}
        >
        </tm-company-user-product-entitlements>`;
    }
}
